export default {"src":"/_next/static/media/ShareButton.3faf8338.svg","height":52,"width":170,"blurWidth":0,"blurHeight":0};